<template>
   <v-card outlined>
    <v-card-title>Add Images</v-card-title>
    <v-card-text>
        <v-file-input v-model="files" outlined multiple />
        <v-btn :loading="saving" @click="upload">Upload</v-btn>
        <template v-if="uploaded.length">
            <v-row class="mt-4">
                <v-col cols="12" class="text-h6 black--text">
                    Uploaded
                </v-col>
            </v-row>
        <v-row v-for="(item, i) in uploaded" :key="i">
            <v-col cols="12">
                {{item.fileName}}
                  <v-icon
                    class="ml-2"
                    @click="copy($event, item.url)"
                  >
                    content_copy
                  </v-icon>
            </v-col>
        </v-row>
    </template>
    </v-card-text>
   </v-card>
  </template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ContentImages',
  data() {
    return { files: [], uploaded: [], saving: false };
  },
  computed: {
    ...mapGetters({ })
  },
  methods: {
    copy(event, value) {
      this.$root.$clipboard(event.clientX, event.clientY, value);
    },
    upload() {
      this.saving = true;
      this.$store
        .dispatch('content/addImages', this.files)
        .then((files) => {
          this.uploaded = this.uploaded.concat(files);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
